import React from 'react';
import { Icons } from './ui/Icons';
import { MediaManager } from './MediaManager';
import { UserProfile, Organization, MediaItem, MediaType } from '../types';

interface MediaPickerProps {
  user: UserProfile;
  organization: Organization | null;
  onSelect: (media: MediaItem) => void;
  onClose: () => void;
  allowedTypes?: MediaType[];
  title?: string;
}

export const MediaPicker: React.FC<MediaPickerProps> = ({
  user,
  organization,
  onSelect,
  onClose,
  allowedTypes = ['image'],
  title = 'Select from Library'
}) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
      <div className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between shrink-0">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icons.Image className="w-5 h-5 text-primary" />
            </div>
            <div>
              <h2 className="text-xl font-bold text-gray-900">{title}</h2>
              <p className="text-sm text-gray-500">
                Choose an existing {allowedTypes.join(' or ')} from your library
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <Icons.X className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto">
          <MediaManager
            user={user}
            organization={organization}
            onLogout={() => {}}
            pickerMode={true}
            allowedTypes={allowedTypes}
            onSelectMedia={(media) => {
              onSelect(media);
              onClose();
            }}
          />
        </div>
      </div>
    </div>
  );
};
